import React from 'react';
import { BASE_PATH } from '../utils/constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = `${BASE_PATH}/`;
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
          <div className="text-center p-4" style={{ maxWidth: '500px' }}>
            <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '4rem' }}></i>
            <h2 className="mt-3 mb-2">Something went wrong</h2>
            <p className="text-muted mb-4">An unexpected error occurred. Please try reloading the page.</p>
            <div className="d-flex gap-2 justify-content-center">
              <button className="btn btn-primary" onClick={this.handleReload}>
                <i className="bi bi-arrow-clockwise me-1"></i> Reload Page
              </button>
              <button className="btn btn-outline-secondary" onClick={this.handleGoHome}>
                <i className="bi bi-house me-1"></i> Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
